import { Dispatch } from 'redux';
import { TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { setColumnOrderAction, setColumnSizeAction } from './actions';
import { PredictionGroupingDtoKeys } from './types';

export function setSize(columnWidths: TableColumnWidthInfoGeneric<PredictionGroupingDtoKeys>[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnSizeAction(columnWidths));
	};
}

export function setOrder(columnOrder: PredictionGroupingDtoKeys[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnOrderAction(columnOrder));
	};
}
